module.exports = __webpack_public_path__ + "img/LOGO_B_TAP.f3f53294.png";